module.exports = __webpack_public_path__ + "img/newrestoratio.d99884ce.png";